var exports = {
  "iE": "EmbedCard.module__wrapper___OV9oWU",
  "p_": "EmbedCard.module__splashWrapper___OV9oWU",
  "Yi": "EmbedCard.module__splash___OV9oWU",
  "Vg": "EmbedCard.module__grid___OV9oWU",
  "iA": "EmbedCard.module__iconSlot___OV9oWU",
  "Qs": "EmbedCard.module__content___OV9oWU",
  "wx": "EmbedCard.module__header___OV9oWU",
  "$": "EmbedCard.module__titleRow___OV9oWU",
  "VA": "EmbedCard.module__subtitle___OV9oWU",
  "rf": "EmbedCard.module__body___OV9oWU",
  "yF": "EmbedCard.module__divider___OV9oWU",
  "DD": "EmbedCard.module__title___OV9oWU",
  "N4": "EmbedCard.module__titleButton___OV9oWU",
  "jn": "EmbedCard.module__titlePrimary___OV9oWU",
  "S3": "EmbedCard.module__titleDanger___OV9oWU",
  "BK": "EmbedCard.module__helpText___OV9oWU",
  "_O": "EmbedCard.module__iconCircleDisabled___OV9oWU",
  "m5": "EmbedCard.module__iconError___OV9oWU",
  "qV": "EmbedCard.module__skeleton___OV9oWU",
  "mj": "EmbedCard.module__skeletonCircle___OV9oWU",
  "Iz": "EmbedCard.module__skeletonTitle___OV9oWU",
  "wS": "EmbedCard.module__skeletonSubtitle___OV9oWU",
  "VR": "EmbedCard.module__skeletonIcon___OV9oWU",
  "X1": "EmbedCard.module__skeletonDot___OV9oWU",
  "gH": "EmbedCard.module__skeletonStat___OV9oWU",
  "Ye": "EmbedCard.module__skeletonStatShort___OV9oWU",
  "KJ": "EmbedCard.module__skeletonStatLong___OV9oWU",
  "G3": "EmbedCard.module__skeletonButton___OV9oWU",
};

module.exports = exports;
